import { getRetailerUrl } from '@shared/constants/routes'
import { type ReadonlyURLSearchParams } from 'next/navigation'

export const getTargetCircleQueryParams = (query: ReadonlyURLSearchParams | null) => {
  const retailer_name = query?.get('retailer_name')
  const redirectUrl = retailer_name ? getRetailerUrl(String(retailer_name)) : undefined

  let params = '?provider=target'
  if (redirectUrl) {
    params += `&returnTo=${redirectUrl}`
  }
  return params
}
